<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/transactionFlowPendingList' }">反匹配待处理</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <div>
                        <el-button size="small" plain @click="updateOrCreate">新增或更新</el-button>
                        <el-button size="small" plain @click="del">删除</el-button>
                        <draggableDetail :draggable="{ data_name: 'transaction_flow_pending' }" @isErrshow="reload"></draggableDetail>
                    </div>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''">
                                        <div class="read_only read_only_link" v-if="in_array(item.prop, ['business_name', 'product_name'])">
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, in_array, processColumnDataToRowNew } from '@/js/common';
import draggableDetail from '../../../common/DrawerDetail.vue';
export default {
    inject: ['reload'],
    name: 'transactionFlowPendingDetail',
    components: {
        draggableDetail
    },
    data() {
        return {
            colData: [],
            activeNames: ['1'],
            data: {},
            queryParams: {},
            headerTitle: '反匹配待处理详情',
            flag: false
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.rid = to.query.id;
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.$nextTick(() => {
            this.getData(); //获取详情
            this.flag = true;
        });
    },
    methods: {
        in_array,
        toDetail(prop) {
            if (prop == 'business_name' && this.data.business_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: this.data.business_rid
                    }
                });
            } else if (prop == 'product_name' && this.data.product_rid != '') {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: this.data.product_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).transaction_flow_pending;
            processColumnDataToRowNew(colData, this);
        },
        //详情
        getData() {
            this.$api
                .transactionFlowPendingDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.rid;
                })
                .catch((error) => {});
        },
        //新增或更新
        updateOrCreate() {
            this.$router.push({
                path: 'transactionFlowPendingEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //删除
        del() {
            onDelete(this.data.id, this, 'transactionFlowPendingDelete', this.data.rid, 'transactionFlowPendingList');
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>